module.exports = __webpack_public_path__ + "img/Recycle.8237c1ab.png";